import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {User} from '../_models/user.model';
import {Router} from '@angular/router';
import {AuthenticationService} from '../_services/authentication.service';
import {MicrosoftGraphService} from '../_services/microsoftGraph.service';
import {DomSanitizer} from '@angular/platform-browser';
import {RendererService} from '../_services/renderer.service';
import {CapaAuthenticationService} from '../_services/capaAuthentication.service';
import {AppGlobal} from '../../environments/app.global';
import {KeycloakService} from 'keycloak-angular';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.css']
})
export class MainHeaderComponent implements OnInit {

    public supportedLanguages: any[];
    public isSupportedLanguage: boolean = false;
    public navigatorLanguage: string;

    private _CurrentUser: User;
    public userPhoto: any;
    get CurrentUser(): User {
        return this._CurrentUser;
    }

    set CurrentUser(user: User) {
        this._CurrentUser = user;
        this.cdRef.detectChanges();
    }

  constructor(private keycloakService: KeycloakService,
              private cdRef: ChangeDetectorRef,
              public router: Router,
              private authenticationService: AuthenticationService,
              private capaAuthService: CapaAuthenticationService,
              private microsoftGraphService: MicrosoftGraphService,
              private sanitizer: DomSanitizer,
              public rendererService: RendererService,
              public GlobalConf: AppGlobal) {

        this.supportedLanguages = [
            { display: 'Français', value: 'fr' },
            { display: 'English', value: 'en' },
            { display: 'Italiano', value: 'it' },
            { display: 'Español', value: 'es' },
            { display: 'Deutsch', value: 'de' },
        ];

        // Ici on regarde si l'utilisateur a une langue de préférence
        this.authenticationService.currentUser.subscribe(user => {
          if (user && user.lang && (window.location.origin !== 'http://localhost:4200')) {
              // if (user.lang !== this.CurrentLang()) {
              //     window.location.href = window.location.origin + environment.basehref + user.lang + '/';
              // }

            if (user.lang !== this.CurrentLang()) {
              this.isSupportedLanguage = this.supportedLanguages.some(obj => obj.value == user.lang);
              //console.log("Current Azure AD User Language = " + user.lang + " / Is supported language = " + this.isSupportedLanguage)

              if (this.isSupportedLanguage)
              {
                window.location.href = window.location.origin + environment.basehref + user.lang + '/';
              }
            }
          }
        });

    }

    logout() {

      // window.location.href = environment.keycloakIssuer + '/protocol/openid-connect/logout';

         this.authenticationService.logout();
        // this.microsoftGraphService = null;
        this.keycloakService.logout(window.location.origin + window.location.pathname).then((result) => {
        });
    }

    logoutCapa() {
      this.capaAuthService.logout();
      this.keycloakService.logout();
      // this.oauthService.logOut();
      this.router.navigate(['capa']);
    }
    /**
     * get current language
     */
    CurrentLang(): string {
      // check if the selected lang is current lang
      return window.location.href
          .split('/')[4];
    }

    /**
     * select laguage
     */
    selectLang(lang: string) {
      // set current lang;
      const langageHeader = this.authenticationService.currentUser.subscribe(user => {
        if (user) {
          if (this.supportedLanguages.findIndex(obj => obj.value === this.CurrentLang()) >= 0) {
            if (lang !== this.CurrentLang() && this.supportedLanguages.some(obj => obj.value == lang) && window.location.origin !== 'http://localhost:4200') {
              this.CurrentUser = user;
              this.CurrentUser.lang = lang;
              this.authenticationService.currentUserValue = this.CurrentUser;
              window.location.href = window.location.origin + environment.basehref + lang + '/';
            } else if (user.lang !== this.CurrentLang() && this.supportedLanguages.some(obj => obj.value == lang)) {
              this.CurrentUser = user;
              this.CurrentUser.lang = lang;
              this.authenticationService.currentUserValue = this.CurrentUser;
              window.location.href = window.location.origin + environment.basehref + lang + '/';
            } else {
              this.CurrentUser = user;
              this.CurrentUser.lang = 'en';
              this.authenticationService.currentUserValue = this.CurrentUser;
              window.location.href = window.location.origin + environment.basehref + 'en' + '/';
            }
          }
        }
      }).unsubscribe();
    }

  /**
   * select laguage by menu
   */
  selectLangByMenu(lang: string) {
    // set current lang;
    this.authenticationService.currentUser.subscribe(user => {
      if (user /*&& this.supportedLanguages.some(obj => obj.value == lang) */&& (window.location.origin !== 'http://localhost:4200')) {
        this.CurrentUser = user;
        this.CurrentUser.lang = lang;
        this.authenticationService.currentUserValue = this.CurrentUser;
        window.location.href = window.location.origin + environment.basehref  + lang + '/';
      }
    });
  }

  ngOnInit() {
    this.CurrentUser = this.authenticationService.currentUserValue;
    const initHeader = this.authenticationService.currentUser.subscribe(user => {
      if (user) {
        if (this.microsoftGraphService.GraphClient) {
          this.initHeader(user);
          initHeader.unsubscribe();
        } else {
          this.microsoftGraphService.GraphClientSubject.subscribe(client =>  {
            if (client) {
              this.initHeader(user);
              initHeader.unsubscribe();
            }
          });
        }
      }
    });
  }

  initHeader(user: User) {
    // Initialisation du header
    this.microsoftGraphService.GraphClient
        .api('https://graph.microsoft.com/v1.0/me/photo/$value').get().then(result2 => {
        this.userPhoto = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(result2));
        this.cdRef.detectChanges();
    }, reason => {
      if (reason.statusCode === 401) {
        this.keycloakService.logout();
        location.reload();
      }
    });

    this.navigatorLanguage = navigator.language;
    console.log("Navigator language = " + this.navigatorLanguage)

    if (!user.lang) {
      this.microsoftGraphService.GraphClient
          .api('https://graph.microsoft.com/v1.0/me/').get().then(resultMe => {
              this.CurrentUser.azure_id = resultMe.id;
              this.authenticationService.currentUserValue = this.CurrentUser;

              // if (resultMe.preferredLanguage) {
              //   console.log("Azure User Preferred Language => " + resultMe.preferredLanguage);
              //   this.selectLang(resultMe.preferredLanguage.substring(0, 2));
              // }
              this.selectLang(this.navigatorLanguage.substring(0, 2));
          }, reason => {
        if (reason.statusCode === 401) {
          this.keycloakService.logout();
          location.reload();
        }
      });
    }
    this.CurrentUser = user;
  }

  hasCapaUser(): boolean {
    return localStorage.getItem('capaAccount') != null;
  }
}
